import { type FC } from 'react'
import { type BookingClient } from '../../../models/Scheduling'
import { clientDisplayName } from '../shared/schedulingDisplay'

// Client names render as plain text in the mock-data phase. Up to two are listed; beyond that the
// first is shown with a "+ N other" overflow, matching the Figma row.
export const ContactChips: FC<{ clients: BookingClient[] }> = ({ clients }) => {
  if (clients.length === 0) {
    return null
  }
  const shown = clients.length <= 2 ? clients : clients.slice(0, 1)
  const otherCount = clients.length - shown.length
  return (
    <span className='d-inline-flex align-items-center flex-wrap zocks-gap-0.25 paragraph-small zocks-text-gray-700'>
      {shown.map((client, index) => (
        <span key={client.contactId ?? client.email ?? index} className='d-inline-flex align-items-center zocks-gap-0.25'>
          <span>{index < shown.length - 1 ? `${clientDisplayName(client)},` : clientDisplayName(client)}</span>
        </span>
      ))}
      {otherCount > 0 ? <span className='zocks-text-gray-600'>+ {otherCount} other</span> : null}
    </span>
  )
}
